import moment from "moment";
import { TAG_TOKEN } from "./config";

/** "14:05" today, "Mon 14:05" this week, "12 Mar" this year, else "12 Mar 2025". */
export function shortTime(value) {
  if (!value) return "";
  const m = moment(value, "YYYY-MM-DD HH:mm:ss");
  const now = moment();
  if (m.isSame(now, "day")) return m.format("HH:mm");
  if (now.diff(m, "days") < 7) return m.format("ddd HH:mm");
  if (m.isSame(now, "year")) return m.format("D MMM");
  return m.format("D MMM YYYY");
}

export function fullTime(value) {
  return value ? moment(value, "YYYY-MM-DD HH:mm:ss").format("ddd D MMM YYYY, HH:mm") : "";
}

/** Split a message body into text and tag parts: [{text}|{tag}]. Unknown tokens stay as text. */
export function bodyParts(body, tags) {
  const byKey = {};
  (tags || []).forEach((t) => {
    byKey[`${t.type}:${t.id}`] = t;
  });

  const parts = [];
  let last = 0;
  const re = new RegExp(TAG_TOKEN.source, "g");
  let m;
  while ((m = re.exec(body || "")) !== null) {
    const tag = byKey[`${m[1]}:${m[2]}`];
    if (!tag) continue;
    if (m.index > last) parts.push({ text: body.slice(last, m.index) });
    parts.push({ tag });
    last = m.index + m[0].length;
  }
  if (last < (body || "").length) parts.push({ text: body.slice(last) });
  return parts;
}

/** Chat name: the other people's names (a subject, if an older chat has one, wins). */
export function conversationTitle(conversation, myId) {
  if (!conversation) return "";
  if (conversation.subject) return conversation.subject;
  const others = (conversation.participants || []).filter((p) => Number(p.user_id) !== Number(myId) && !p.left);
  return others.map((p) => p.name).join(", ") || "Just you";
}

export function initials(name) {
  return (name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}

/** Message text without its [[type:id]] tag tokens (tags are shown behind the tag icon). */
export function stripTokens(body) {
  return (body || "")
    .replace(new RegExp(TAG_TOKEN.source, "g"), "")
    .replace(/[ \t]+(?=\n)/g, "")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
}

/** "Today", "Yesterday", "Monday", "12 March 2026" — for date separators in a chat. */
export function dayLabel(value) {
  const m = moment(value, "YYYY-MM-DD HH:mm:ss");
  const now = moment();
  if (m.isSame(now, "day")) return "Today";
  if (m.isSame(now.clone().subtract(1, "day"), "day")) return "Yesterday";
  if (now.diff(m, "days") < 7) return m.format("dddd");
  return m.format(m.isSame(now, "year") ? "D MMMM" : "D MMMM YYYY");
}

export function clock(value) {
  return value ? moment(value, "YYYY-MM-DD HH:mm:ss").format("HH:mm") : "";
}

/** The other people in a chat (everyone but me who hasn't left). */
export function otherPeople(conversation, myId) {
  return (conversation?.participants || []).filter((p) => Number(p.user_id) !== Number(myId) && !p.left);
}
